import "./app.css";
import { useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
	useLocation,
} from "react-router-dom";
import { AuthContext } from "./context/authContext/AuthContext";
import Navbar from "./components/navbar/Navbar";
import Sidebar from "./components/sidebar/Sidebar";
import Dashboard from "./pages/dashboard/Dashboard";
import Orders from "./pages/orders/Orders";
import Claims from "./pages/claims/Claims";
import NewClaim from "./pages/newClaim/NewClaim";
import Login from "./pages/login/Login";
import RegisterInfo from "./pages/registerInfo/RegisterInfo";
import Register from "./pages/register/Register";
import Claim from "./pages/claim/Claim";

function RequireAuth({ children }) {
  const { user } = useContext(AuthContext);
  let location = useLocation();
	
  return user ? children : <Navigate to="/login" replace={true} state={location.pathname} />;
}

function App() {
  // if (!user) {
  //   return (
  //     <Router>
  //       <Routes>
  //         <Route path="/register/:userId/:token" element={<RegisterInfo />} />
  //         <Route path="/register/:userId" element={<Register />} />
  //         <Route path="/" element={<Login />} />
  //       </Routes>
  //     </Router>
  //   );
  // }

  return (
    <Router>
      <Navbar />
      <div className="container">
        <Sidebar />
        <Routes>
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/orders/:orderId/newClaim"
            element={
              <RequireAuth>
                <NewClaim />
              </RequireAuth>
            }
          />
          <Route
            path="/orders/:orderId/"
            element={
              <RequireAuth>
                <Orders />
              </RequireAuth>
            }
          />
          <Route
            path="/orders"
            element={
              <RequireAuth>
                <Orders />
              </RequireAuth>
            }
          />
          <Route
            path="/claims/:claimId"
            element={
              <RequireAuth>
                <Claim />
              </RequireAuth>
            }
          />
          <Route
            path="/claims"
            element={
              <RequireAuth>
                <Claims />
              </RequireAuth>
            }
          />
					<Route path="/register/:userId/:token" element={<RegisterInfo />} />
					<Route path="/register/:userId" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
